import { FC, createContext, useContext, useState } from 'react'
import { WithChildren } from '../../../../../../general/helpers'

const initPaymentSchemesDashboardContextPropsState = {
    filtersType: undefined,
    saveFiltersType: () => { },
    selectedFilterType: undefined,
}
const PaymentSchemesDashboardContext = createContext<any>(initPaymentSchemesDashboardContextPropsState)

const usePaymentSchemesDash = () => {
    return useContext(PaymentSchemesDashboardContext)
}

const PaymentSchemesDashboardProvider: FC<WithChildren> = ({ children }) => {
    const [filtersType, setFiltersType] = useState()
    const [selectedFilterType, setSelectedFilterType] = useState()
    const [querylistings, setQuerylistings] = useState()
    const [labels, setLabels] = useState()
    const saveSelectedFilterType = (value) => {
        setSelectedFilterType(value)
    }
    const saveFiltersType = (filters_types) => {
        setFiltersType(filters_types)
    }
    const saveQueryListings = (listings) => {
        setQuerylistings(listings)
    }
    const saveLabels = (label) => {
        setLabels(label)
    }

    return (
        <>
            <PaymentSchemesDashboardContext.Provider
                value={{
                    filtersType,
                    saveFiltersType,
                    selectedFilterType,
                    saveSelectedFilterType,
                    querylistings,
                    saveQueryListings,
                    labels,
                    saveLabels,
                }}
            >
                <div className='position-relative'>{children}</div>
            </PaymentSchemesDashboardContext.Provider>
        </>
    )
}
export { usePaymentSchemesDash, PaymentSchemesDashboardProvider }
